import {Component, OnInit} from '@angular/core';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {Router} from '@angular/router';
import {AuthService} from 'projects/firebase/src/lib/services/auth.service';
import {GoogleTagService} from 'projects/shared/src/lib/services/google-tag.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm-sign-in',
    templateUrl: './confirm-sign-in.component.html',
    styleUrls: ['./confirm-sign-in.component.scss']
})
export class ConfirmSignInComponent implements OnInit {
    user;
    email = '';
    url = '';
    emailSent = false;

    errorMessage: string;

    constructor(
        public afAuth: AngularFireAuth,
        private router: Router,
        private auth: AuthService,
        private gtService: GoogleTagService,
        private modal: NgbActiveModal,
    ) {
    }

    ngOnInit() {
        this.user = this.afAuth.user;
        this.email = window.localStorage.getItem('emailForSignIn') || '';
    }

    confirmEmail() {
        const email: string = this.email;

        this.auth.confirmSignIn(email, this.url)
            .then(() => this.gtService.event('login_success'))
            .then((res) => {
                this.router.navigate(['/']);
                this.modal.close();
            }, (error) => {
            });

    }

    logout() {
        return this.afAuth.signOut();
    }

    onClose() {
        this.router.navigate(['/']);
        this.modal.close();
    }
}
